import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter()

    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const { id } = useParams();

    const path = '/projectindicators/';
    const paths = {
        endpointSave: config.endpoints.backend + 'projects/save',
        endpointGetById: config.endpoints.backend + 'projects/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Projeto",
        labelTitleEdit: "Editar Indicadores",
        labelTitleView: 'Visualizar Indicadores'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                    readOnly: true
                },
                {
                    name: 'id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                    readOnly: true
                },
                {
                    name: 'indicators',
                    type: 'multiinput',
                    label: 'Indicadores',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Nome',
                            type: 'text',
                            name: 'indicator_name',
                            validations: {
                                required: true
                            },
                            maxLength: 500
                        },
                        {
                            label: 'Link',
                            type: 'text',
                            name: 'indicator_link',
                            validations: {
                                required: true
                            },
                            maxLength: 500
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
